import { render, staticRenderFns } from "./BreadcrumbsField.vue?vue&type=template&id=11a94536&scoped=true&"
import script from "./BreadcrumbsField.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsField.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbsField.vue?vue&type=style&index=0&id=11a94536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a94536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBreadcrumbs,VBtn,VIcon,VTooltip})
